var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"cluster-member-community-list",attrs:{"type":"div","name":"fade"}},_vm._l((_vm.visibleLogos),function(logo){return _c('div',{key:logo.id,staticClass:"cluster-member-item"},[_c('a',{staticClass:"cluster-member-icon",attrs:{"href":logo.url}},[_c('img',{attrs:{"src":logo.image,"alt":logo.title}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }